// Política de entrega del pie de la tienda. Única regla de «qué texto aplica»:
// la usan GroceryShell y RestaurantMicrosite. MÓDULO PURO (sin hooks): el traductor llega de fuera.
import { usesLocalFulfillmentPolicy, type StorefrontKind } from "@/lib/microsite/storefrontKind"

export type FulfillmentPolicyKey = "pickup" | "pickupDelivery" | "pickupShip" | "pickupDeliveryShip"

export function fulfillmentPolicyKey(args: { deliveryEnabled: boolean; shippingEnabled: boolean }): FulfillmentPolicyKey {
  if (args.deliveryEnabled && args.shippingEnabled) return "pickupDeliveryShip"
  if (args.deliveryEnabled) return "pickupDelivery"
  if (args.shippingEnabled) return "pickupShip"
  return "pickup"
}

/**
 * `t` resuelve claves relativas a `public.microsite.grocery.fulfillmentPolicy` (`label`, `pickup`…).
 * Restaurante (o tipo ausente) → undefined: el pie conserva el texto de main.
 */
export function buildFulfillmentPolicy(
  args: { storefrontKind: StorefrontKind | undefined; deliveryEnabled: boolean; shippingEnabled: boolean },
  t: (key: string) => string,
): { label: string; text: string } | undefined {
  if (!usesLocalFulfillmentPolicy(args.storefrontKind)) return undefined
  return { label: t("label"), text: t(fulfillmentPolicyKey(args)) }
}
